import { render, staticRenderFns } from "./radioSamootchetMismatchList.vue?vue&type=template&id=458ac5c6"
import script from "./radioSamootchetMismatchList.vue?vue&type=script&lang=js"
export * from "./radioSamootchetMismatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports